import React from 'react'
import { usePostRequest } from '../hooks/request'
import { MANTHLY_RESULT_ITEM_LIST } from '../urls'
import ManthlyResultItemForm from './ManthlyResultItemForm'

export default function ManthlyResultItemCreate({ onCancel, onSuccess, finance, rotationId }) {
    const monthCreate = usePostRequest({ url: MANTHLY_RESULT_ITEM_LIST.replace('{resultId}', finance.id) })

    async function onSubmit(data) {
        const { success } = await monthCreate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <b>Добавить</b><br /><br />
            <ManthlyResultItemForm
                finance={finance}
                rotationId={rotationId}
                onSubmit={onSubmit}
                onCancel={onCancel}
                loading={monthCreate.loading} />
        </div>
    )
}
